import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { CTAAction } from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import { TApiAction } from "@/redux/store.types";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    product: CartItemModel | null;
};

const AcceptNegativeDeliveryPromiseAction = ({ product }: Props) => {
    const dispatch = useThunkDispatch();
    const { closeDialog, setLoading } = useCallToActionsContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (product) {
            setLoading(true);
            dispatch(
                CartModule.acceptNegativeDeliveryPromise(product.sku)
            ).then((action: TApiAction) => {
                if (action.type === CartModule.APIStatus.SUCCESS) {
                    closeDialog();
                }
            });
        }
    }, []);

    return null;
};

const acceptNegativeDeliveryPromise: CTAAction = (
    product: CartItemModel | null
) => {
    return <AcceptNegativeDeliveryPromiseAction product={product} />;
};

export default acceptNegativeDeliveryPromise;
